import { useCallback, useState } from "react";
import UploadIcon2 from "@assets/icons/new/upload-2_50px.svg?react";
import { FaroIconButton } from "@components/common/faro-icon-button";
import { SphereTooltip } from "@components/common/sphere-tooltip";
import { FolderInput, FolderInputProps } from "@pages/data-management/import-data/folder-input";
import { openFileExplorer } from "@pages/data-management/import-data/import-data-utils";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { DataManagementEvents } from "@utils/track-event/track-event-list";

/** Icon button that opens a folder selection dialog for re-upload. */
export function AddDataButton({
  project,
  uploadedIdsMap,
  setFileInfos,
  setIsFileExplorerOpen,
  isDropzoneLoading,
  setIsDropzoneLoading,
}: Omit<FolderInputProps, "setFileInput">): JSX.Element {
  const { trackEvent } = useTrackEvent();

  const [fileInput, setFileInput] = useState<HTMLInputElement | null>(null);

  /** Opens the browser's file input dialog. */
  const openExplorer = useCallback(() => {
    trackEvent({ name: DataManagementEvents.addData });
    openFileExplorer(fileInput, setIsFileExplorerOpen);
  }, [fileInput, setIsFileExplorerOpen, trackEvent]);

  return (
    <>
      <FolderInput
        project={project}
        uploadedIdsMap={uploadedIdsMap}
        setFileInfos={setFileInfos}
        setIsFileExplorerOpen={setIsFileExplorerOpen}
        isDropzoneLoading={isDropzoneLoading}
        setIsDropzoneLoading={setIsDropzoneLoading}
        setFileInput={setFileInput}
      />
      <SphereTooltip title="Add Data">
        <FaroIconButton
          dataTestId="sa-add-data"
          component={UploadIcon2}
          isDisabled={isDropzoneLoading}
          onClick={openExplorer}
        />
      </SphereTooltip>
    </>
  );
}
